import React from 'react';
import { Route } from 'react-router-dom';

import http from 'api/http';
import { componentFamilyAPI } from 'api/requests';

import NewFamily from './New';
import Details from './Details';
import Edit from './Edit';

export default class Application extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      familyInfo: {
        name: '',
        type: {},
        notes: '',
        testReports: [],
        status: '',
        components: [],
      },
      requestInProcess: true,
    };
  }

  componentDidMount() {
    const { match } = this.props;
    const { familyId } = match.params;

    if (isFinite(familyId)) {
      http.get(componentFamilyAPI.info(familyId)).then(({ data }) => {
        this.setState({ familyInfo: data });
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      (this.state.familyInfo.name || !isFinite(this.props.match.params.familyId)) &&
      this.state.requestInProcess &&
      this.props.components &&
      this.props.types &&
      this.props.families &&
      this.props.categories
    ) {
      this.setState({ requestInProcess: false });
    }

    if (prevProps.match.params.familyId !== this.props.match.params.familyId) {
      if (isFinite(this.props.match.params.familyId)) {
        this.setState({ requestInProcess: true }, () => {
          http.get(componentFamilyAPI.info(this.props.match.params.familyId)).then(({ data }) => {
            this.setState({ familyInfo: data });
          });
        });
      }
    }
  }

  changeStatus = newStatusString => {
    const { id, name, notes, submissionDate, type, components } = this.state.familyInfo;
    const { updateFamiliesListEntry } = this.props;

    components.forEach(component => (component.applicationStatus = newStatusString));

    this.setState(
      prevState => {
        return { familyInfo: { ...prevState.familyInfo, status: newStatusString, components } };
      },
      () => {
        updateFamiliesListEntry(
          {},
          {
            id: id,
            name: name,
            notes: notes,
            status: this.state.familyInfo.status,
            submissionDate: submissionDate,
            type: type,
          }
        );
      }
    );
  };

  updateFamilyInfo = data => {
    const { updateFamiliesListEntry } = this.props;

    this.setState({ familyInfo: { ...data } }, () => {
      updateFamiliesListEntry({}, data);
    });
  };

  render() {
    const {
      match,
      user,
      createFamilyActionsList,
      performFamilyActionFunction,
      updateFamiliesListEntry,
      types,
      categories,
      components,
      componentsRequestInProcess,
    } = this.props;
    const { requestInProcess, familyInfo } = this.state;

    return (
      <main className='scene-wrapper'>
        <Route
          exact
          path={`${match.path.slice(0, -9)}new`}
          render={() => (
            <NewFamily
              {...this.state}
              types={types}
              categories={categories}
              components={components}
              user={user}
              componentsRequestInProcess={componentsRequestInProcess}
              updateFamiliesListEntry={updateFamiliesListEntry}
            />
          )}
        />
        <Route
          exact
          path={`${match.path}/details`}
          render={() => (
            <Details
              {...this.state}
              user={user}
              match={match}
              requestInProcess={requestInProcess}
              performFamilyActionFunction={performFamilyActionFunction}
              updateFamiliesListEntry={updateFamiliesListEntry}
              categories={categories}
              changeStatus={this.changeStatus}
              availableActions={createFamilyActionsList(familyInfo.status)}
            />
          )}
        />
        <Route
          exact
          path={`${match.path}/edit`}
          render={() => (
            <Edit
              {...this.state}
              user={user}
              fieldsList={this.fieldsList}
              categories={categories}
              components={components}
              requestInProcess={requestInProcess}
              componentsRequestInProcess={componentsRequestInProcess}
              createFamilyActionsList={createFamilyActionsList}
              performFamilyActionFunction={performFamilyActionFunction}
              updateFamiliesListEntry={this.updateFamilyInfo}
            />
          )}
        />
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/ComponentFamily/index.jsx